<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    v-on:after-leave="$emit('left')">
    <div v-if="show" :class="classes">
      <div class="modal-background" @click="deactivate"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-translate="interpolation">{{title}}</p>
          <button class="delete" @click="deactivate"></button>
        </header>
        <section class="modal-card-body">
          <slot name="card-comment-content"></slot>
          <slot name="card-content"></slot>
          <transition
              name="fade"
              appear
              appear-active-class="animated fadeIn"
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
              :duration="{ enter: 200, leave: 200 }">
              <div class="columns">
                <div class="column is-12">
                  <div v-if="parentMixin && parentMixin.error" class="notification is-danger">{{ parentMixin.error }}</div>
                </div>
              </div>
          </transition>
        </section>
        <footer class="modal-card-foot">
          <slot name="card-footer">
            <!-- Action buttons -->
            <div v-if="hasActionButtons"
              class="field is-grouped">
              <div class="control">
                <submit-btn-component
                  v-if="options.hasOkBtn"
                  class="is-primary"
                  @submit="$emit('handleOk', $event)">
                  <slot name="ok-text">OK</slot>
                </submit-btn-component>
              </div>
              <div class="control">
                <button
                  v-if="options.hasCancelBtn"
                  class="button is-danger is-outlined"
                  @click="$emit('handleCancel', $event)"
                  v-translate>
                  <slot name="cancel-text">Avbryt</slot>
                </button>
              </div>
            </div>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'

  export default {
    name: 'card-modal-component',
    components: {
      SubmitBtnComponent
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      transition: {
        type: String,
        default: 'fade'
      },
      title: {
        type: String
      },
      interpolation: {
        type: Object,
        default: () => {}
      },
      options: {
        type: Object,
        default: () => ({
          hasOkBtn: { enabled: true },
          hasCancelBtn: { enabled: true }
        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      visible () {
        return getComputedStyle(this.$el).getPropertyValue('display') === 'none'
      },
      leaveClass () {
        return `${this.transition}Out`
      },
      classes () {
        return ['modal', 'animated', 'is-active']
      },
      hasActionButtons () {
        return this.options.hasOkBtn.text || this.options.hasOkBtn.enabled ||
          this.options.hasCancelBtn.text || this.options.hasCancelBtn.enabled
      },
      parentMixin () {
        return this.$parent.mixin
      }
    },
    methods: {
      deactivate () {
        this.$emit('deactivate', false)
      },
      closeModal () {
        return new Promise(resolve => this.$el.style === undefined ? resolve() : this.$once('left', () => resolve()))
      }
    },
    mounted () {
      document.body.appendChild(this.$el)
    },
    beforeDestroy () {
      document.body.contains(this.$el) && document.body.removeChild(this.$el)
    }
  }
</script>

<style lang="sass" scoped>
  .modal-card-body
    overflow-x: hidden
    overflow-y: auto
</style>
